

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('g', {"clip-path":"url(#svg-plane-arrival-I05Cg4O)"}, ["\n", h('path', {"d":"M4.67852 7.81846L7.42273 8.55426L10.7796 9.45426C11.2848 9.59005 11.8027 9.29005 11.9385 8.78479C12.0743 8.27952 11.7743 7.76162 11.269 7.62585L7.9122 6.72585L6.1722 1.02901L4.95009 0.700562V5.93003L1.8143 5.09003L1.22693 3.62476L0.311157 3.37846V6.64689L1.32483 6.91846L4.67852 7.81846Z","fill":"#342245"}, []), "\n", h('path', {"d":"M12.1406 11.4374H0.140625V12.7005H12.1406V11.4374Z","fill":"#342245"}, []), "\n"]), "\n", h('defs', {}, ["\n", h('clipPath', {"id":"svg-plane-arrival-I05Cg4O"}, ["\n", h('rect', {"width":"12","height":"12","fill":"white","transform":"translate(0.140625 0.700562)"}, []), "\n"]), "\n"]), "\n"]);
};

        